import { memo } from 'react';
import { ComponentMemo } from '@headless-workspace/typings';
import { GlowSkeleton } from '../../atoms';

export const ProductTileImgSkeleton: ComponentMemo = memo(() => {
    return (
        <GlowSkeleton
            containerClassName={
                'mx-auto h-productTileImgMobile w-productTileImgMobile tablet:h-productTileImg tablet:w-productTileImg'
            }
        />
    );
});

export const ProductTileContentSkeleton: ComponentMemo = memo(() => {
    return (
        <>
            <GlowSkeleton width={'4rem'} height={'1.5rem'} />
            <GlowSkeleton width={'6.938rem'} height={'0.938rem'} />
            <GlowSkeleton width={'6.938rem'} height={'0.938rem'} />
        </>
    );
});

ProductTileContentSkeleton.displayName = 'ProductTileContentSkeleton';
ProductTileImgSkeleton.displayName = 'ProductTileImgSkeleton';
